import DonationSettings from "./DonationSettings";

export default DonationSettings;